export default "__VITE_PUBLIC_ASSET__dcb2caae__"